import { Injectable } from '@angular/core';
import { Veiculo } from '@tivic-team/manager-ts/dist/fta/entities/veiculo.entity';
import { HttpGet, HttpPost, HttpPut, HttpResponse, JSONData, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { environment } from 'src/environments/environment';


@Injectable()
export class VeiculoController{

    constructor() {}

    async consultarDetran(nrPlaca:string):Promise<JSON>{
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'fta/veiculos/detran/:placa',
                    environment: environment,
					pathParams: new JSONData({placa: nrPlaca})
                }),
            }),
            new HttpResponse(
                new JSONData()
            )
        );
        return await quark.call();
    }

    async create(veiculo: Veiculo): Promise<Veiculo> {
		let quark = new Quark(
			new HttpPost({
				url: new Url({
					id: 'fta/veiculos',
					environment: environment
				}),
				data: new JSONData(veiculo)
			}),
			new HttpResponse(
				new Veiculo()
			)
		);
		return await quark.call();
	}

	async update(veiculo: Veiculo): Promise<Veiculo> {
		let quark = new Quark(
			new HttpPut({
				url: new Url({
					id: 'fta/veiculos',
					environment: environment,
					pathParams: new JSONData({ veiculo: veiculo.cdVeiculo })
				}),
				data: new JSONData(veiculo)
			}),
			new HttpResponse(
				new Veiculo()
			)
		);
		return await quark.call();
	}
    
}